// extracted by mini-css-extract-plugin
export var addToCartButton = "_n5-b";
export var arrowButtonContainer = "_n5-9";
export var arrowButtonIcon = "_n5-a";
export var carouselArrowButton = "_n5-6";
export var carouselElementContainer = "_n5-1";
export var left = "_n5-7";
export var productDisplayCarouselContainer = "_n5-0";
export var productTileContainer = "_n5-2";
export var productTileImage = "_n5-4";
export var productTileImageContainer = "_n5-3";
export var productTileTitle = "_n5-5";
export var right = "_n5-8";
export var sliderOverflow = "_n5-c";